import * as Types from '../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ConsentToScheduleApplyMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ConsentToScheduleApplyMutation = { __typename?: 'Mutation', ghostwriter: { __typename?: 'GhostwriterMutations', consentToScheduleApply: { __typename?: 'ConsentToScheduleApplyPayload', consentRecorded: boolean, userErrors: Array<{ __typename?: 'GhostwriterUserError', message: string, field?: Array<string> | null, code?: string | null }> } } };


export const ConsentToScheduleApplyDocument = gql`
    mutation ConsentToScheduleApply {
  ghostwriter {
    consentToScheduleApply {
      consentRecorded
      userErrors {
        message
        field
        code
      }
    }
  }
}
    `;
export type ConsentToScheduleApplyMutationFn = Apollo.MutationFunction<ConsentToScheduleApplyMutation, ConsentToScheduleApplyMutationVariables>;

/**
 * __useConsentToScheduleApplyMutation__
 *
 * To run a mutation, you first call `useConsentToScheduleApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsentToScheduleApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consentToScheduleApplyMutation, { data, loading, error }] = useConsentToScheduleApplyMutation({
 *   variables: {
 *   },
 * });
 */
export function useConsentToScheduleApplyMutation(baseOptions?: Apollo.MutationHookOptions<ConsentToScheduleApplyMutation, ConsentToScheduleApplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsentToScheduleApplyMutation, ConsentToScheduleApplyMutationVariables>(ConsentToScheduleApplyDocument, options);
      }
export type ConsentToScheduleApplyMutationHookResult = ReturnType<typeof useConsentToScheduleApplyMutation>;
export type ConsentToScheduleApplyMutationResult = Apollo.MutationResult<ConsentToScheduleApplyMutation>;
export type ConsentToScheduleApplyMutationOptions = Apollo.BaseMutationOptions<ConsentToScheduleApplyMutation, ConsentToScheduleApplyMutationVariables>;